/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-unescaped-entities */
//Dummy Commit for release

import React, { useState } from "react";
import { get } from "lodash";
import { Helmet } from "react-helmet";
import "./index.scss";
import { encryptData, getRootUrl } from "../../utils/commonFunctions";
import DOBScreen from "./DOBScreen";
import metaLogo from "../../assets/guardian.png";
import SecurityCode from "./SecurityScreen";
import LinkExpired from "./ErrorContainer/LinkExpired";
import Header from "../../components/Header";
import { useIdleTimer } from "react-idle-timer";
import TokenError from "./ErrorContainer/TokenError";
import { Registartion } from "./RegistrationScreen";
import FailedRegistration from "./ErrorContainer/FailedRegistration";


const WelcomeExperience = () => {
  const [dobData, setDobData] = useState({});
  const [nextStep, setNextStep] = useState(1);
  const [isIdle, setIsIdle] = useState(false);
  const [userStatus, setUserStatus] = useState("");
  const [registrationData, setRegistrationData] = useState({});
  const timeout = 1000 * 10 * 60;

  console.log(" data inside registrationData>>>>", registrationData);

  const handleOnIdle = () => {
    return setIsIdle(true);
  };
  // eslint-disable-next-line
  useIdleTimer({
    timeout,
    onIdle: handleOnIdle,
  });

  const url = window.location.search;
  const identityToken = new URLSearchParams(url).get("identity");

  const updateDobData = (dobApiResponse, userEnteredDob) => {
    setDobData({dobApiResponse, userEnteredDob: encryptData(userEnteredDob)});
  };

  const getNextStepComponent = () => {
    switch (nextStep) {
      case 1:
        return (
          <div>
            <Header />
            <div className="welcomeExperience__container">
              <Helmet>
                <title>Verify your Identity | Register For Guardian Anytime</title>
                <link rel="icon" type="image/png" href={metaLogo} />
              </Helmet>
              <div className="welcomeExperience__body" role="main">
                <DOBScreen
                  updateDobData={updateDobData}
                  identityToken={identityToken}
                  setNextStep={setNextStep}
                  setUserStatus={setUserStatus}
                />
              </div>
            </div>
          </div>
        );
      case 2:
        return (
          <SecurityCode
            identityToken={identityToken}
            email={get(dobData, "dobApiResponse.email")}
            setNextStep={setNextStep}
            userStatus={userStatus}
          />
        );
      case 3:
        return (
          <Registartion
            identityToken={identityToken}
            setNextStep={setNextStep}
            setRegistrationData={setRegistrationData}
            plainEmailId={get(dobData, "dobApiResponse.plainEmailId", "")}
            firstName={get(dobData, "dobApiResponse.firstName", "")}
            lastName={get(dobData, "dobApiResponse.lastName", "")}
            dob={get(dobData, "userEnteredDob", null)}
            phoneNumber={get(dobData, "dobApiResponse.plainPhoneNumber", "")}
          />
        );
      case 4:
        return <TokenError />;
      case 5:
        return <FailedRegistration token={identityToken} message={get(registrationData, "message", "")} />
      default:
        return <LinkExpired />;
    }
  };

  return (
    <>
      {isIdle
        ? (window.location.href = `${getRootUrl()}/userver/ga/sessiontimeout`)
        : getNextStepComponent()}
    </>
  );
};

export default WelcomeExperience;
